import styled from 'styled-components'
import { Text } from '@sketch/components'

export const RadioLabel = styled(Text).attrs({
  textStyle: 'copy.tertiary.standard.E',
})`
  padding-bottom: 8px !important; /* stylelint-disable-line declaration-no-important */
`

export const FormLabel = styled(Text).attrs({
  textStyle: 'copy.tertiary.standard.E',
})`
  padding-bottom: 8px !important; /* stylelint-disable-line declaration-no-important */
  padding-top: 20px;
`
